import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DownloadSimple, FilePdf, FileDoc, CaretDown } from "@phosphor-icons/react";
import { downloadFile } from "@/lib/api";
import { toast } from "sonner";

// A shared dropdown used across modules for PDF / Word export
export function ExportMenu({ endpointPath, baseName, testId = "export-menu", size = "sm" }) {
  async function handleExport(fmt) {
    try {
      await downloadFile(`${endpointPath}/${fmt}`, `${baseName}.${fmt === "pdf" ? "pdf" : "docx"}`);
      toast.success(`Downloaded ${fmt.toUpperCase()}`);
    } catch (e) {
      toast.error("Export failed");
    }
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size={size} data-testid={testId} className="border-border">
          <DownloadSimple size={14} className="mr-2" /> Export
          <CaretDown size={12} className="ml-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleExport("pdf")} data-testid={`${testId}-pdf`}>
          <FilePdf size={16} className="mr-2" /> Export as PDF
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleExport("docx")} data-testid={`${testId}-docx`}>
          <FileDoc size={16} className="mr-2" /> Export as Word
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
